import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO } from '../../constants/contact';
import { APP_VERSION } from '../../constants/version';
import PaymentMethodBadges from './PaymentMethodBadges';

export default function Footer() {
  return (
    // Added footer-custom class for specific link styling
    <footer className="footer-custom text-center text-lg-start bg-main text-white w-100 mt-auto">
        <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
            <div className="me-5 d-none d-lg-block">
            <span>Get connected with us on social networks:</span>
            </div>

            <div>
            {/* Social links - SVGs will inherit color from parent text-white, or can be styled directly */}
            <a href="#!" className="me-4 text-reset footer-icon-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
                </svg>
            </a>
            <a href="#!" className="me-4 text-reset footer-icon-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter" viewBox="0 0 16 16">
                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
                </svg>
            </a>
            {/* Add other social links as needed */}
            </div>
        </section>

        <section className="">
            <div className="container text-center text-md-start mt-5">
            <div className="row mt-3">
                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Pack My Cart</h6>
                <p>
                    Your one-stop solution for convenient grocery shopping from local supermarkets.
                </p>
                </div>

                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Useful links</h6>
                <p><Link to="https://rosue.pro" className="footer-text-link">About Us</Link></p>
                <p><Link to="/how-it-works" className="footer-text-link">How It Works</Link></p>
                <p><Link to="/faq" className="footer-text-link">FAQ</Link></p>
                <p><Link to="https://rosue.pro" className="footer-text-link">Contact</Link></p>
                <p><Link to="/privacy-policy" className="footer-text-link">Privacy Policy</Link></p>
                <p><Link to="/terms-of-service" className="footer-text-link">Terms of Service</Link></p>
                </div>

                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p>{CONTACT_INFO.address}</p>
                <p>{CONTACT_INFO.email}</p>
                {/* <p>{CONTACT_INFO.phone}</p> */}
                </div>
            </div>
            </div>
        </section>

        <section className="footer-payment-methods text-center py-4 border-top">
            <p className="small text-uppercase fw-semibold mb-3">We Accept</p>
            <PaymentMethodBadges />
        </section>

        <div className="text-center p-4" style={{backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
            <p className="mb-1 small text-white-50">Version {APP_VERSION}</p>
            <p className="mb-0">
              © {new Date().getFullYear()} Copyright:{' '}
              <a
                href="https://rosue.pro"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-text-link"
              >
                RosuePro Website Development
              </a>
            </p>
        </div>
    </footer>
  )
}
